import { type SvgIconComponent } from '@root/lib/types/components';

import { EnumHelper } from './helpers';

/**
 * ItemType enumeration
 * @enum {number}
 * @export
 */
export enum ITEM_TYPE {
	EVENT_ENTRY = 1,
	PARKING = 2,
	CHIP = 3,
	ATTRACTION_ADMISSION = 4,
	WORKSHOP = 5,
	PRODUCT = 6,
	REPEATED_EVENT_ENTRY = 7,
	CHIP_VIP = 8,
	ZONE = 9,
}

/**
 * Extra data interface for Item Type
 * @export
 */
export interface ItemTypeExtraData {
	Icon?: SvgIconComponent;
}

/**
 * ItemType data type
 * @export
 */
export interface ItemTypeData extends ItemTypeExtraData {
	itemTypeId: ITEM_TYPE;
}

/**
 * List of supported item types
 * @see https://github.com/NFCtron/nfctron-db/blob/dev/diagrams/ticket-config.png
 * @type {ItemTypeData[]}
 */
/**
 * ItemType enumeration class
 * @export
 */
class ItemTypeEnum extends EnumHelper<ItemTypeExtraData, ITEM_TYPE, 'itemType', 'itemTypeId'> {
	constructor() {
		super(
			'itemType',
			{
				[ITEM_TYPE.EVENT_ENTRY]: {},
				[ITEM_TYPE.PARKING]: {},
				[ITEM_TYPE.CHIP]: {},
				[ITEM_TYPE.ATTRACTION_ADMISSION]: {},
				[ITEM_TYPE.WORKSHOP]: {},
				[ITEM_TYPE.PRODUCT]: {},
				[ITEM_TYPE.REPEATED_EVENT_ENTRY]: {},
				[ITEM_TYPE.CHIP_VIP]: {},
				[ITEM_TYPE.ZONE]: {},
			},
			'itemTypeId',
			null,
		);
	}
}

/**
 * ItemType enumeration singleton instance export
 * @type {ItemTypeEnum}
 * @export
 */
export const itemTypeEnum = new ItemTypeEnum();
